import '../assets/NcListItem-BIFTbr17.css';
import { N as l } from "./NcActions-B1Ue3gj8.mjs";
import r from "../Components/NcCounterBubble.mjs";
import c from "../Components/NcVNodes.mjs";
import { r as u, h as d, a as h } from "./_l10n-BZu8wI2q.mjs";
import { n as m } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
u(d);
const f = {
  name: "NcListItem",
  components: {
    NcActions: l,
    NcCounterBubble: r,
    NcVNodes: c
  },
  props: {
    /**
     * The details text displayed in the upper right part of the component
     */
    details: {
      type: String,
      default: ""
    },
    /**
     * Name (first line of text)
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Pass in `true` if you want the matching behavior to
     * be non-inclusive: https://router.vuejs.org/api/#exact
     */
    exact: {
      type: Boolean,
      default: !1
    },
    /**
     * The route for the router link.
     */
    to: {
      type: [String, Object],
      default: null
    },
    /**
     * The value for the external link
     */
    href: {
      type: String,
      default: "#"
    },
    target: {
      type: String,
      default: ""
    },
    /**
     * Id for the `<a>` element
     */
    anchorId: {
      type: String,
      default: ""
    },
    /**
     * Make subname bold
     */
    bold: {
      type: Boolean,
      default: !1
    },
    /**
     * Show the NcListItem in compact design
     */
    compact: {
      type: Boolean,
      default: !1
    },
    /**
     * Toggle the active state of the component
     */
    active: {
      type: Boolean,
      default: !1
    },
    /**
     * Aria label for the wrapper element
     */
    linkAriaLabel: {
      type: String,
      default: ""
    },
    /**
     * Aria label for the actions toggle
     */
    actionsAriaLabel: {
      type: String,
      default: ""
    },
    /**
     * If different from 0 this component will display the
     * NcCounterBubble component
     */
    counterNumber: {
      type: [Number, String],
      default: 0
    },
    /**
     * Outlined or highlighted state of the counter
     */
    counterType: {
      type: String,
      default: "",
      validator(s) {
        return ["highlighted", "outlined", ""].indexOf(s) !== -1;
      }
    },
    /**
     * To be used only when the elements in the actions menu are very important
     */
    forceDisplayActions: {
      type: Boolean,
      default: !1
    },
    /**
     * Show the list component layout
     */
    oneLine: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "click",
    "update:menuOpen"
  ],
  data() {
    return {
      hovered: !1,
      hasActions: !1,
      hasSubname: !1,
      displayActionsOnHoverFocus: !1,
      menuOpen: !1,
      hasIndicator: !1,
      hasDetails: !1
    };
  },
  computed: {
    showAdditionalElements() {
      return !this.displayActionsOnHoverFocus || this.forceDisplayActions;
    },
    showDetails() {
      return (this.details !== "" || this.hasDetails) && (!this.displayActionsOnHoverFocus || this.forceDisplayActions);
    },
    computedActionsAriaLabel() {
      return this.actionsAriaLabel || h('Actions for item with name "{name}"', { name: this.name });
    }
  },
  watch: {
    menuOpen(s) {
      !s && !this.hovered && (this.displayActionsOnHoverFocus = !1);
    }
  },
  mounted() {
    this.checkSlots();
  },
  updated() {
    this.checkSlots();
  },
  methods: {
    /**
     * Handle link click
     *
     * @param {MouseEvent|KeyboardEvent} event - Native click or keydown event
     * @param {Function} [navigate] - VueRouter link's navigate if any
     * @param {string} [routerLinkHref] - VueRouter link's href
     */
    onClick(s, t, e) {
      this.$emit("click", s), !(s.metaKey || s.altKey || s.ctrlKey || s.shiftKey) && e && (t == null || t(s), s.preventDefault());
    },
    showActions() {
      this.hasActions && (this.displayActionsOnHoverFocus = !0), this.hovered = !1;
    },
    hideActions() {
      this.displayActionsOnHoverFocus = !1;
    },
    /**
     * @param {FocusEvent} event UI event
     */
    handleBlur(s) {
      this.menuOpen || this.$refs["list-item"].contains(s.relatedTarget) || this.hideActions();
    },
    /**
     * Hide the actions on mouseleave unless the menu is open
     */
    handleMouseleave() {
      this.menuOpen || (this.displayActionsOnHoverFocus = !1), this.hovered = !1;
    },
    handleMouseover() {
      this.showActions(), this.hovered = !0;
    },
    handleActionsUpdateOpen(s) {
      this.menuOpen = s, this.$emit("update:menuOpen", s);
    },
    // Check if subname and actions slots are populated
    checkSlots() {
      this.hasActions !== !!this.$slots.actions && (this.hasActions = !!this.$slots.actions), this.hasSubname !== !!this.$slots.subname && (this.hasSubname = !!this.$slots.subname), this.hasIndicator !== !!this.$slots.indicator && (this.hasIndicator = !!this.$slots.indicator), this.hasDetails !== !!this.$slots.details && (this.hasDetails = !!this.$slots.details);
    }
  }
};
var p = function() {
  var t = this, e = t._self._c;
  return e(t.to ? "router-link" : "NcVNodes", { tag: "component", attrs: { custom: t.to ? !0 : null, to: t.to, exact: t.to ? t.exact : null }, scopedSlots: t._u([{ key: "default", fn: function({ href: n, navigate: o, isActive: a }) {
    return [e("li", { staticClass: "list-item__wrapper", class: { "list-item__wrapper--active": a || t.active } }, [e("div", { ref: "list-item", staticClass: "list-item", class: {
      "list-item--compact": t.compact,
      "list-item--one-line": t.oneLine
    }, on: { mouseover: t.handleMouseover, mouseleave: t.handleMouseleave } }, [e("a", { staticClass: "list-item__anchor", attrs: { id: t.anchorId || void 0, "aria-label": t.linkAriaLabel, href: n || t.href, target: t.target || (t.href === "#" ? void 0 : "_blank"), rel: t.href === "#" ? void 0 : "noopener noreferrer" }, on: { focus: t.showActions, focusout: t.handleBlur, click: function(i) {
      return t.onClick(i, o, n);
    }, keydown: function(i) {
      return !i.type.indexOf("key") && t._k(i.keyCode, "esc", 27, i.key, ["Esc", "Escape"]) ? null : t.hideActions.apply(null, arguments);
    } } }, [t._t("icon"), e("div", { staticClass: "list-item-content" }, [e("div", { staticClass: "list-item-content__main" }, [e("div", { staticClass: "list-item-content__name" }, [t._t("name", function() {
      return [t._v(t._s(t.name))];
    })], 2), t.hasSubname ? e("div", { staticClass: "list-item-content__subname", class: { "list-item-content__subname--bold": t.bold } }, [t._t("subname")], 2) : t._e()]), e("div", { staticClass: "list-item-content__details" }, [t.showDetails ? e("div", { staticClass: "list-item-details__details" }, [t._t("details", function() {
      return [t._v(t._s(t.details))];
    })], 2) : t._e(), t.counterNumber != 0 || t.hasIndicator ? e("div", { directives: [{ name: "show", rawName: "v-show", value: t.showAdditionalElements, expression: "showAdditionalElements" }], staticClass: "list-item-details__extra" }, [t.counterNumber != 0 ? e("NcCounterBubble", { staticClass: "list-item-details__counter", attrs: { active: a || t.active, type: t.counterType } }, [t._v(" " + t._s(t.counterNumber) + " ")]) : t._e(), t.hasIndicator ? e("span", { staticClass: "list-item-details__indicator" }, [t._t("indicator")], 2) : t._e()], 1) : t._e()])])], 2), e("div", { directives: [{ name: "show", rawName: "v-show", value: t.forceDisplayActions || t.displayActionsOnHoverFocus, expression: "forceDisplayActions || displayActionsOnHoverFocus" }], staticClass: "list-item-content__actions", on: { focusout: t.handleBlur } }, [e("NcActions", { ref: "actions", attrs: { primary: a || t.active, "aria-label": t.computedActionsAriaLabel }, on: { "update:open": t.handleActionsUpdateOpen } }, [t._t("actions")], 2)], 1), t.$slots.extra ? e("div", { staticClass: "list-item__extra" }, [t._t("extra")], 2) : t._e()])])];
  } }], null, !0) });
}, _ = [], y = /* @__PURE__ */ m(
  f,
  p,
  _,
  !1,
  null,
  "6eacaffe",
  null,
  null
);
const w = y.exports;
export {
  w as N
};
